import React, { useMemo } from "react";
import Icons from "../../Constants/Icons";
import { useNavigate } from "react-router-dom";
import moment from "moment";

const ReferralUserList = ({ currentUsers = [] }) => {
  const navigate = useNavigate();

  const handleUserNavigation = (userId) => {
    if (userId) {
      navigate("/UserProfile", { state: { userId } });
    }
  };

  const renderUserCell = (userId, userName, userEmail, profileImage, onClick) => (
    <div
      className="premium-user-cell"
      onClick={onClick}
    >
      <div className="premium-user-info">
        <div className="premium-avatar-wrapper">
          <img
            src={profileImage || Icons.ic_default_user}
            alt={userName}
            className="premium-user-avatar"
            onError={(e) => {
              e.target.src = Icons.ic_default_user;
            }}
          />
        </div>
        <div className="premium-user-details">
          <div className="premium-user-name">{userName || "—"}</div>
          <div className="premium-user-email">{userEmail || ""}</div>
        </div>
      </div>
    </div>
  );

  return (
    <div className="premium-user-list-wrapper">
      <div className="premium-scroll-container">
        {currentUsers.map((item, index) => (
          <div key={item.referralId || index} className="premium-table-row">
            {/* Referred By Column */}
            {renderUserCell(
              item.referrerByUserId,
              item.referredByName,
              item.referredByEmail,
              item.referredByProfileImageURL,
              () => handleUserNavigation(item.referrerByUserId)
            )}

            {/* Referred User Column */}
            {renderUserCell(
              item.referredUserId,
              item.referredUserName,
              item.referredUserEmail,
              item.referredProfileImageURL,
              () => handleUserNavigation(item.referredUserId)
            )}

            {/* Date Column */}
            <div className="premium-date-cell">
              {moment(item.createdAt).format("DD MMM YYYY")}
            </div>
          </div>
        ))}
      </div>

      <style>{`
        .premium-user-list-wrapper {
          width: 100%;
        }

        .premium-scroll-container {
          width: 100%;
          max-height: 500px;
          overflow-y: auto;
          overflow-x: hidden;
        }

        /* Hide scrollbar but keep functionality */
        .premium-scroll-container::-webkit-scrollbar {
          width: 0px;
          background: transparent;
          display: none;
        }

        .premium-scroll-container {
          scrollbar-width: none;
          -ms-overflow-style: none;
        }

        .premium-table-row {
          display: flex;
          padding: 16px 24px;
          border-bottom: 1px solid rgba(255, 255, 255, 0.05);
          transition: all 0.2s ease;
          cursor: pointer;
        }

        .premium-table-row:hover {
          background: rgba(255, 255, 255, 0.04);
        }

        /* Fixed width distribution */
        .premium-user-cell {
          width: 40%;
          display: flex;
          align-items: center;
        }

        .premium-date-cell {
          width: 20%;
          font-size: 13px;
          color: #a5adce;
          display: flex;
          align-items: center;
        }

        .premium-user-info {
          display: flex;
          align-items: center;
          gap: 12px;
          width: 100%;
          cursor: pointer;
        }

        .premium-avatar-wrapper {
          display: inline-block;
          line-height: 0;
          flex-shrink: 0;
        }

        .premium-user-avatar {
          width: 44px;
          height: 44px;
          border-radius: 50%;
          object-fit: cover;
          border: 2px solid transparent;
          transition: all 0.25s ease;
        }

        .premium-user-details {
          display: flex;
          flex-direction: column;
          gap: 4px;
          flex: 1;
          min-width: 0;
        }

        .premium-user-name {
          font-size: 14px;
          font-weight: 500;
          color: #ffffff;
          transition: all 0.25s ease;
          word-break: break-word;
        }

        .premium-user-email {
          font-size: 12px;
          color: #6b7299;
          word-break: break-word;
        }

        /* Hover Effects - Image hover affects name, Name hover affects image */
        .premium-avatar-wrapper:hover .premium-user-avatar {
          border-color: #818cf8;
          transform: scale(1.05);
        }

        .premium-avatar-wrapper:hover ~ .premium-user-details .premium-user-name,
        .premium-avatar-wrapper:hover + .premium-user-details .premium-user-name {
          color: #818cf8;
        }

        .premium-user-details:hover .premium-user-name {
          color: #818cf8;
        }

        .premium-user-details:hover ~ .premium-avatar-wrapper .premium-user-avatar,
        .premium-user-info:hover .premium-user-avatar {
          border-color: #818cf8;
          transform: scale(1.05);
        }

        /* Both hover effects combined */
        .premium-user-info:hover .premium-user-avatar {
          border-color: #818cf8;
          transform: scale(1.05);
        }

        .premium-user-info:hover .premium-user-name {
          color: #818cf8;
        }

        /* Responsive Design */
        @media (max-width: 768px) {
          .premium-scroll-container {
            max-height: 400px;
          }

          .premium-table-row {
            padding: 12px 16px;
            flex-wrap: wrap;
          }

          .premium-user-cell {
            width: 50%;
          }

          .premium-date-cell {
            width: 100%;
            margin-top: 12px;
            padding-left: 56px;
          }

          .premium-user-avatar {
            width: 36px;
            height: 36px;
          }

          .premium-user-name {
            font-size: 13px;
          }

          .premium-user-email {
            font-size: 11px;
          }
        }

        @media (max-width: 480px) {
          .premium-scroll-container {
            max-height: 350px;
          }

          .premium-table-row {
            flex-direction: column;
            gap: 12px;
          }

          .premium-user-cell {
            width: 100%;
          }

          .premium-date-cell {
            width: 100%;
            padding-left: 0;
            margin-top: 0;
          }
        }

        /* Animation */
        @keyframes fadeInUp {
          from {
            opacity: 0;
            transform: translateY(10px);
          }
          to {
            opacity: 1;
            transform: translateY(0);
          }
        }

        .premium-table-row {
          animation: fadeInUp 0.3s ease forwards;
        }
      `}</style>
    </div>
  );
};

export default React.memo(ReferralUserList);